var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6554 8.81462V7.39359C10.656 6.43316 10.3243 5.50062 9.7141 4.74678C9.10387 3.99294 8.25075 3.46187 7.29269 3.23944C7.29998 3.21188 7.30566 3.18394 7.30969 3.15575V1.28946C7.30969 1.08008 7.2244 0.879281 7.07258 0.731228C6.92077 0.583175 6.71486 0.5 6.50016 0.5C6.28546 0.5 6.07956 0.583175 5.92774 0.731228C5.77593 0.879281 5.69064 1.08008 5.69064 1.28946V3.15575C5.69467 3.18394 5.70034 3.21188 5.70764 3.23944C4.74958 3.46187 3.89645 3.99294 3.28622 4.74678C2.67599 5.50062 2.34434 6.43316 2.34488 7.39359V8.81462C2.34488 10.6983 0.833496 11.1688 0.833496 12.1106C0.833496 12.5788 0.833496 13.0525 1.26902 13.0525H11.7313C12.1668 13.0525 12.1668 12.5788 12.1668 12.1106C12.1668 11.1688 10.6554 10.6983 10.6554 8.81462Z",
    fill: "#4C6AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92831 13.8419C4.14305 14.3338 4.50136 14.7532 4.95864 15.048C5.41592 15.3428 5.95199 15.5 6.50016 15.5C7.04833 15.5 7.58441 15.3428 8.04169 15.048C8.49897 14.7532 8.85727 14.3338 9.07202 13.8419H3.92831Z",
    fill: "#4C6AF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBell);
export default __webpack_public_path__ + "static/media/blue_bell.ac37412a066efc78f7ff208020c3e1db.svg";
export { ForwardRef as ReactComponent };